import { diffWords } from 'diff'
import { ADD_TYPES } from './AddTextDescription'

export const splitSuggestedtext = (impactedText: string, suggestedText: string) => {
  const updatedWordsList = diffWords(impactedText, suggestedText)

  let prefix = ''
  let suffix = ''
  let highlightedText = ''
  let addType = ADD_TYPES.BETWEEN // default

  updatedWordsList.forEach((updatedWord, index) => {
    if (updatedWord.added) {
      if (index === 0) addType = ADD_TYPES.BEFORE // word added at start of a sentence
      if (index === updatedWordsList.length - 1) addType = ADD_TYPES.AFTER // word added at end of a sentence
      highlightedText += updatedWord.value
    } else if (highlightedText) {
      // if new added word already found, means succeeding words are suffix
      suffix += updatedWord.value
    } else {
      prefix += updatedWord.value
    }
  })
  if (suffix.trim().length === 0) addType = ADD_TYPES.AFTER
  if (prefix.trim().length === 0) addType = ADD_TYPES.BEFORE
  return { suffix, prefix, highlightedText, addType }
}
